module.exports = __webpack_public_path__ + "media/images/new_culture/factor-altruism-3bac82370dc44e06fd0830f6d820a4ad.png";